"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var react_1 = __importDefault(require("react"));
var react_tooltip_1 = __importDefault(require("react-tooltip"));
var lodash_1 = require("lodash");
var icon_1 = require("../icon");
var Tooltip = function (props) {
    var id = (0, lodash_1.uniqueId)("tooltip-");
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(icon_1.Icon, { icon: icon_1.help, size: 16, "data-tip": "", "data-for": id }),
        react_1.default.createElement(react_tooltip_1.default, { id: id, html: typeof props.tooltip === "string" ? true : false, effect: "solid" }, props.tooltip)));
};
exports.Tooltip = Tooltip;
